import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ListFilter } from 'admin/appModel/Filter';
import { WindowRef } from 'admin/utile/services/WindowRef ';
import { AppService } from '_public/templates/main/app.service';
import { TemplatePreviewComponent } from '_public/templates/main/template-preview/template-preview.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector   : 'public-template-app',
    template: require('./app.component.html'),
    styles: [require('./app.component.scss')]
})
export class AppComponent implements OnInit
{
    private pageSize = 10;
    private filter: ListFilter = new ListFilter();

    templatesPage: number = 1;
    templatesTotal: number = 0;
    templates: any[];

    constructor(
        private windowRef: WindowRef,
        private bottomSheet: MatBottomSheet,
		private appService: AppService,
		private spinner: NgxSpinnerService) { }

	async ngOnInit(): Promise<void> {
		await this.clearTemplates();
        this.filter.PageNumber = this.templatesPage;
        this.filter.PageSize = this.pageSize;
        await this.getTemplates();
    }

	private async prev(): Promise<void> {
		this.windowRef.Window.scrollTo(0, 0);
		await this.clearTemplates();
        this.filter.PageNumber = this.templatesPage - 1;
        await this.getTemplates();
    }

	private async next(): Promise<void> {
		this.windowRef.Window.scrollTo(0, 0);
		await this.clearTemplates();
        this.filter.PageNumber = this.templatesPage + 1;
        await this.getTemplates();
    }

	private async clearTemplates(): Promise<void> {
		await this.spinner.show("publicTemplateListSpinner");
		this.templates = null;
	}

    private async getTemplates(): Promise<void> {
        let response: any;

        try {
            response = await this.appService.GetTemplates(this.filter).toPromise();
        }
        catch (err) {
            console.error(err);
        }

        if (!response.success) {
            console.error(response.error);
        }

		await this.spinner.hide("publicTemplateListSpinner");

        this.templatesPage = response.data.Page;
        this.templatesTotal = response.data.Total;
		this.templates = response.data.Items;
		
        if (this.templates.length == 0 && this.filter.PageNumber > 1) {
            this.filter.PageNumber--;
            await this.getTemplates();
        }
    }

    private previewTemplate(template: any): void {
        const config = {
            //backdropClass: "template-preview-backdrop",
            panelClass: "template-preview",
            data: { template }
        };

        const bottomSheetRef = this.bottomSheet.open(TemplatePreviewComponent, config);
    }
}
